var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { select } from '@wordpress/data';
import ParticipantForm from './components/ParticipantForm';
function getOrCreateSessionId() {
    var cookieName = 'wccf_session_id';
    var existing = document.cookie.split('; ').find(function (row) { return row.startsWith(cookieName + '='); });
    if (existing)
        return existing.split('=')[1];
    var newId = Math.random().toString(36).substring(2) + Date.now().toString(36);
    document.cookie = "".concat(cookieName, "=").concat(newId, "; path=/; max-age=31536000"); // 1 year
    return newId;
}
// Add a global boolean for enabling/disabling debug logs
var enableLogging = false;
var App = function () {
    var _a = useState(false), globalDataLoaded = _a[0], setGlobalDataLoaded = _a[1];
    var _b = useState([]), validationErrors = _b[0], setValidationErrors = _b[1];
    var _c = useState(false), isVerifying = _c[0], setIsVerifying = _c[1];
    var errorBoxRef = useRef(null);
    useEffect(function () {
        // Fetch cart data from WooCommerce
        var fetchCartData = function () {
            var _a, _b, _c;
            if (window.wc_cart && Array.isArray(window.wc_cart)) {
                // Filter products by those that have resolved settings
                // (settings will be false for products not in enabled categories)
                var products = window.wc_cart.filter(function (item) {
                    return item.settings !== false && item.settings !== undefined;
                });
                // Get t-shirt sizes from global settings (used as default in GlobalData)
                var tshirtSizes = (((_a = window.wccfSettings) === null || _a === void 0 ? void 0 : _a.tshirtSizes) || ['XS', 'S', 'M', 'L', 'XL', 'XXL']);
                window.wccfData = {
                    cartItems: products,
                    tShirtSizes: __spreadArray(__spreadArray([], tshirtSizes, true), [''], false)
                };
                if (enableLogging || ((_b = window.wccfSettings) === null || _b === void 0 ? void 0 : _b.debugMode)) {
                    console.log('Settings mode:', (_c = window.wccfSettings) === null || _c === void 0 ? void 0 : _c.settingsMode);
                    console.log('Filtered products:', products);
                    console.log('Global t-shirt sizes:', tshirtSizes);
                    console.log('Updated global data:', window.wccfData);
                }
                setGlobalDataLoaded(true);
            }
            else {
                console.error('WooCommerce cart data not found or invalid.');
                console.log('window.wc_cart:', window.wc_cart); // Log the entire wc_cart object for debugging
            }
        };
        fetchCartData();
    }, []);
    useEffect(function () {
        var _a;
        if (validationErrors.length > 0) {
            (_a = errorBoxRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [validationErrors]);
    useEffect(function () {
        var checkoutButton = document.querySelector('.wc-block-components-checkout-place-order-button');
        if (checkoutButton) {
            var bypassIntercept_1 = false;
            checkoutButton.addEventListener('click', function (e) { return __awaiter(void 0, void 0, void 0, function () {
                var buttonEl, errors, participantForms, participantData, flattenedParticipants, response, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (bypassIntercept_1) {
                                // Our own re-dispatch after a successful save — let it bubble to WooCommerce's real submit handler,
                                // but still block the native default action (form submit) to avoid triggering extra click dispatches.
                                bypassIntercept_1 = false;
                                e.preventDefault();
                                return [2 /*return*/];
                            }
                            e.preventDefault(); // Prevent checkout submission
                            e.stopImmediatePropagation(); // Block WooCommerce's own submit handler until our save completes
                            buttonEl = checkoutButton;
                            buttonEl.disabled = true; // Visual feedback so users don't click again while we save in the background
                            errors = validateFields();
                            if (errors.length > 0) {
                                e.preventDefault(); // Prevent checkout submission
                                buttonEl.disabled = false;
                                setValidationErrors(errors);
                                console.log('Please fix the errors before proceeding to checkout.');
                                return [2 /*return*/];
                            }
                            setIsVerifying(true);
                            participantForms = document.querySelectorAll('[participant-data]');
                            participantData = Array.from(participantForms).map(function (form) {
                                var entries = { participants: [] };
                                form.querySelectorAll('[required-data]').forEach(function (input) {
                                    var _a;
                                    var product_id = input.getAttribute('data-product-id');
                                    var participant_id = parseInt(input.getAttribute('data-participant-id'), 10) || 0;
                                    var name = input.name || input.getAttribute('data-label');
                                    var value = input.value;
                                    var order_id = (_a = select('wc/store/checkout').getOrderId()) !== null && _a !== void 0 ? _a : 0; // Draft order ID from WooCommerce's own checkout store
                                    console.log("Collecting field: order_id=".concat(order_id, ", product_id=").concat(product_id, ", participant_id=").concat(participant_id, ", name=").concat(name, ", value=").concat(value));
                                    // Ensure the field is structured correctly
                                    if (!name || !value) {
                                        console.error("Malformed field detected: name=".concat(name, ", value=").concat(value));
                                        return;
                                    }
                                    if (enableLogging) {
                                        console.log("Field collected: name=".concat(name, ", value=").concat(value));
                                    }
                                    // Find or create entry for this product_id and participant_id
                                    var entry = entries.participants.find(function (e) { return e[1] === product_id && e[2] === participant_id + 1; });
                                    if (!entry) {
                                        entry = [order_id, product_id, participant_id + 1, []];
                                        entries.participants.push(entry);
                                    }
                                    entry[3].push([name, value]);
                                });
                                return entries;
                            });
                            flattenedParticipants = participantData.flatMap(function (entry) { return entry.participants; });
                            // Nothing to save (order has no competition products) — proceed straight to checkout.
                            if (flattenedParticipants.length === 0) {
                                buttonEl.disabled = false; // must re-enable first, a disabled button won't dispatch a click
                                setIsVerifying(false);
                                bypassIntercept_1 = true;
                                // Defer past this click's own dispatch — click() is a no-op while a click on the
                                // same element is still in progress (re-entrancy guard in the HTML click() spec).
                                setTimeout(function () { return buttonEl.click(); }, 0);
                                return [2 /*return*/];
                            }
                            if (enableLogging) {
                                console.log('Sending participant data to server:', participantData);
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, fetch('/wp-json/wccf/v1/save-participant-data', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-WCCF-Session-ID': getOrCreateSessionId(),
                                    },
                                    body: JSON.stringify({ participants: flattenedParticipants })
                                })];
                        case 2:
                            response = _a.sent();
                            if (!response.ok) {
                                e.preventDefault();
                                buttonEl.disabled = false;
                                setIsVerifying(false);
                                console.log('Error saving participant data. Please try again.');
                                return [2 /*return*/];
                            }
                            if (enableLogging) {
                                console.log('Participant data saved successfully.');
                            }
                            // Proceed with checkout after transient is saved. Re-enable first — a disabled button
                            // won't dispatch a click event, which would break this re-entry.
                            buttonEl.disabled = false;
                            setIsVerifying(false);
                            bypassIntercept_1 = true;
                            buttonEl.click();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.error('Error saving participant data:', error_1);
                            buttonEl.disabled = false;
                            setIsVerifying(false);
                            e.preventDefault();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        }
        else {
            console.error('Checkout button not found.');
        }
    }, [globalDataLoaded]);
    var validateFields = function () {
        if (enableLogging) {
            console.log('Starting validation of participant forms...');
        }
        var errors = [];
        var participantForms = document.querySelectorAll('[participant-data]');
        if (enableLogging) {
            console.log('Validating participant forms:', participantForms.length);
        }
        participantForms.forEach(function (form, idx) {
            var requiredInputs = form.querySelectorAll('[required-data]');
            if (enableLogging) {
                console.log("Form ".concat(idx + 1, ": Found ").concat(requiredInputs.length, " required inputs"));
            }
            requiredInputs.forEach(function (input) {
                var _a, _b, _c;
                if (enableLogging) {
                    console.log("Checking input:", input);
                }
                var label = input.getAttribute('data-label') || input.name || "Field ".concat(input.name);
                var product_name = input.getAttribute('data-product-name') || 'Unknown';
                var participant_id = parseInt(input.getAttribute('data-participant-id'), 10) || idx;
                if (!input.value || (typeof input.value === 'string' && !input.value.trim())) {
                    console.log("Waarde ontbreekt voor: ".concat(label));
                    errors.push("<strong>".concat(product_name, "</strong> Deelnemer ").concat(participant_id + 1, ": ").concat(label, " is verplicht."));
                }
                // Validate date of birth
                if (input.name === 'dateOfBirth') {
                    var dateOfBirth = new Date(input.value);
                    var today = new Date();
                    var age = today.getFullYear() - dateOfBirth.getFullYear();
                    var monthDiff = today.getMonth() - dateOfBirth.getMonth();
                    var dayDiff = today.getDate() - dateOfBirth.getDate();
                    // Adjust age if the birthdate hasn't occurred yet this year
                    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
                        age--;
                    }
                    // Get age range from product-specific resolved settings
                    var product_id_1 = input.getAttribute('data-product-id');
                    var cartItem = (_a = window.wccfData) === null || _a === void 0 ? void 0 : _a.cartItems.find(function (item) { return item.product_id.toString() === product_id_1; });
                    var ageMin = ((cartItem === null || cartItem === void 0 ? void 0 : cartItem.settings) && typeof cartItem.settings === 'object') ? cartItem.settings.age_min : (((_b = window.wccfSettings) === null || _b === void 0 ? void 0 : _b.ageMin) || 6);
                    var ageMax = ((cartItem === null || cartItem === void 0 ? void 0 : cartItem.settings) && typeof cartItem.settings === 'object') ? cartItem.settings.age_max : (((_c = window.wccfSettings) === null || _c === void 0 ? void 0 : _c.ageMax) || 99);
                    if (age < ageMin || age > ageMax) {
                        console.log("Ongeldige leeftijd voor geboortedatum: ".concat(input.value));
                        errors.push("<strong>".concat(product_name, "</strong> Deelnemer ").concat(participant_id + 1, ": ").concat(label, " moet resulteren in een leeftijd tussen ").concat(ageMin, " en ").concat(ageMax, " jaar."));
                    }
                }
            });
        });
        if (enableLogging) {
            console.log('Validation errors:', errors);
        }
        return errors;
    };
    if (!globalDataLoaded) {
        return (React.createElement("div", { className: "text-red-500" },
            React.createElement("p", null, "Error: Global data not loaded. Please ensure the WooCommerce cart is available and contains items in the \"wave\" or \"klimclub-jongeren\" category.")));
    }
    var _d = window.wccfData, _e = _d.cartItems, cartItems = _e === void 0 ? [] : _e, tShirtSizes = _d.tShirtSizes;
    if (!cartItems || cartItems.length === 0) {
        return (React.createElement("div", { className: "" }));
    }
    return (React.createElement("div", { className: "space-y-2 my-8" },
        React.createElement("h2", { className: "text-2xl font-semibold text-gray-800 border-b" }, "Deelnemer details"),
        React.createElement("div", { className: "bg-blue-100 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md", role: "alert" },
            React.createElement("p", { className: "font-bold m-0" }, "Vul de verplichte gegevens hieronder in.")),
        validationErrors.length > 0 && (React.createElement("div", { ref: errorBoxRef, className: "bg-red-50 border-2 border-red-600 text-red-800 p-4 rounded-md", role: "alert" },
            React.createElement("p", { className: "font-bold" }, "Controleer je gegevens"),
            React.createElement("ul", { className: "ml-4 md:ml-10 lg:ml-14 list-disc" }, validationErrors.map(function (error, index) { return (React.createElement("li", { key: index, dangerouslySetInnerHTML: { __html: error } })); })))),
        validationErrors.length > 0 && (React.createElement("style", null, '.wccf-show-invalid [required-data]:invalid { border-color: #dc2626; background-color: #fef2f2; }')),
        cartItems.map(function (item) {
            if (enableLogging) {
                console.log('Rendering ParticipantForm for item:', item); // Debugging log
            }
            return (React.createElement("div", { className: validationErrors.length > 0 ? 'wccf-show-invalid' : '', key: "wrap-".concat(item.product_id) },
                React.createElement(ParticipantForm, { item: item, tShirtSizes: tShirtSizes })));
        }),
        isVerifying && (React.createElement(React.Fragment, null,
            React.createElement("style", null, '@keyframes wccf-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }'),
            React.createElement("p", { "aria-live": "polite", style: {
                    textAlign: 'center',
                    fontWeight: 600,
                    color: '#4e7c78',
                    animation: 'wccf-pulse 1.5s ease-in-out infinite',
                } }, "Bezig met controleren, even geduld...")))));
};
export default App;
